<template>
    <div class="app-footer">Copyright © 2025-2026 香港医学人才中心学习平台. All Rights Reserved.</div>
</template>

<script>
    export default {
        name: "app-footer"
    }
</script>

<style scoped>
.app-footer{
    text-align: center;
    line-height: 50px;
    height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppFooter.vue